<template>
  <div class="row">
    <div class="col-lg-12">
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card card-custom gutter-b">
          <div class="card-header card-header-tabs-line">
            <div class="card-title">
              <h3 class="card-label">File ATG Application</h3>
            </div>
          </div>
          <div class="card-body">
            <b-form-group label="E-Receipt Provider" label-for="provider">
              <b-form-select
                name="provider"
                v-model="form.providerId"
                :options="options.providers"
                size="sm"
                text-field="ProviderName"
                value-field="ProviderId"
                @change="setSelectedProvider"
              ></b-form-select>
              <b-form-invalid-feedback>
                E-Receipt Provider.
              </b-form-invalid-feedback>
            </b-form-group>
            <div class="bg-light p-5 mb-5">
              <div class="d-flex flex-wrap mt-1">
                <div class="mr-12 d-flex flex-column">
                  <span class="d-block font-weight-bold mb-1 text-muted"
                    >Provider TIN</span
                  >
                  <span class="pt-1 text-break"
                    >{{ form.provider.ProviderTin }}-{{
                      form.provider.ProviderBranchCode
                    }}</span
                  >
                </div>
                <div class="mr-12 d-flex flex-column">
                  <span class="d-block font-weight-bold mb-1 text-muted"
                    >Provider Accreditation Number</span
                  >
                  <span class="pt-1 text-break">{{
                    form.provider.ProviderAccreditationNumber
                  }}</span>
                </div>
                <div class="mr-12 d-flex flex-column">
                  <span class="d-block font-weight-bold mb-1 text-muted"
                    >Provider Accreditation Date</span
                  >
                  <span class="pt-1 text-break">{{
                    form.provider.ProviderDateOfAccreditation
                      | moment("MMMM D, YYYY")
                  }}</span>
                </div>
              </div>
              <div class="d-flex justify-content-between mt-5">
                <div class="mr-12 d-flex flex-column">
                  <span class="d-block font-weight-bold mb-1 text-muted"
                    >Provider Address</span
                  >
                  <span class="pt-1">{{ form.provider.ProviderAddress }}</span>
                </div>
              </div>
            </div>
            <b-form-group label="Branch / Business Profile" label-for="profile">
              <b-form-select
                name="profile"
                :state="validateState('profileId')"
                v-model="form.profileId"
                :options="options.branches"
                size="sm"
                text-field="DisplayName"
                value-field="ProfileId"
              ></b-form-select>
              <b-form-invalid-feedback>
                Branch / Business Profile is required.
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Type">
              <b-form-checkbox-group
                v-model="form.types"
                :options="options.types"
                :state="validateState('types')"
              ></b-form-checkbox-group>
              <b-form-invalid-feedback>
                Application Type is required.
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="card-footer">
            <div class="d-flex flex-wrap flex-center">
              <button
                ref="submit"
                :disabled="this.isBusy || $v.$invalid || !$v.$anyDirty"
                class="btn btn-primary mx-4"
                type="submit"
              >
                File Application
              </button>
              <BackButton></BackButton>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
// import ApiServiceLibrary from "@/core/services/api.service.library";
import BackButton from "@/view/content/widgets/backbutton.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mask } from "vue-the-mask";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";
import Swal from "sweetalert2";

Vue.use(require("vue-moment"));

export default {
  mixins: [validationMixin],
  name: "topup-transactions-create",
  components: { BackButton },
  directives: { mask },
  props: {},
  data() {
    return {
      isBusy: false, //isNew: false,
      form: {
        providerId: "",
        provider: {
          ProviderName: ""
        },
        profileId: "",
        types: []
      },
      options: {
        providers: [],
        branches: [],
        types: [
          { text: "Services (Official Receipt)", value: "Services" },
          { text: "Goods (Sales Invoice)", value: "Goods" }
        ]
      }
    };
  },
  validations: {
    form: {
      providerId: { required },
      profileId: { required },
      types: { required }
      // providername: { required },
      // providertin: { required },
      // provideraccreditationnumber: { required },
      // providerdateofaccreditation: { required },
      // provideraddress: { required }
    }
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    //console.log("clinics-createupdate.mounted");
    this.init();
  },
  methods: {
    init() {
      //console.log("this.agencyId:", this.agencyId);
      //console.log("CommonService.isGuidEmpty(this.agencyId):", CommonService.isGuidEmpty(this.agencyId));
      this.resetForm();
      this.getProviders();
      this.getBranches();

      this.setBreadcrumbs("File ATG Application");
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Authority to Generate",
          route: "/easyreceipt"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        providerId: "",
        provider: {
          ProviderName: ""
        },
        profileId: "",
        types: []
      };

      this.$nextTick(() => {
        this.$v.$reset();
        this.$v.form.$touch();
      });
    },
    getProviders() {
      var self = this;
      self.isBusy = true;
      return new Promise(resolve => {
        let param = {};
        ApiService.get("providers/getlist", param)
          .then(({ data }) => {
            this.$gtag.event("providers_getlist", param);
            self.options.providers = data;
            if (data && data.length > 0) {
              self.form.providerId = data[0].ProviderId;
              this.setSelectedProvider();
            }
            self.isBusy = false;
            window.scrollTo(0, 0);
            resolve(data);
            return data;
          })
          .catch(() => {
            self.options.providers = [];
            self.isBusy = false;
            window.scrollTo(0, 0);
          });
      });
    },
    setSelectedProvider() {
      this.form.provider = this.options.providers.find(
        item => item.ProviderId === this.form.providerId
      );
    },
    getBranches() {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = {};
        ApiService.get("business/me", param)
          .then(({ data }) => {
            this.$gtag.event("business_me", param);
            self.options.branches = data.MetadataObject.Profiles;
            if (self.options.branches && self.options.branches.length > 0)
              self.form.profileId = self.options.branches[0].ProfileId;
            self.isBusy = false;
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.confirmCreate();
    },
    confirmCreate() {
      Swal.fire({
        //title: 'Are you sure?',
        html: "Are you sure you want file this application?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.isConfirmed) {
          this.create();
        }
      });
    },
    create() {
      let self = this;
      self.isBusy = true;
      let param = {
        ProviderId: self.$v.form.providerId.$model,
        BusinessProfileId: self.$v.form.profileId.$model,
        IsService: self.$v.form.types.$model.includes("Services"),
        IsGoods: self.$v.form.types.$model.includes("Goods")
      };
      const submitButton = self.$refs["submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      ApiService.put("easyreceipt/create", param)
        .then(({ data }) => {
          this.$gtag.event("atg_create", param);
          if (data) {
            self.isBusy = false;
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
            this.$router.push({ name: "easyreceipt-applications-list" });
          }
        })
        .catch(() => {
          self.isBusy = false;
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    }
  },
  watch: {
    agencyId(newValue, oldValue) {
      if (newValue != oldValue) {
        this.init();
      }
    }
  }
};
</script>
